;(function() {
  const alignRightClsn = 'dropdown-align-right';
  const dropdownMenuSlct = '.dropdown-menu:not(.dropdown-menu .dropdown-menu)';

  updateAlignments();
  window.addEventListener('resize', debounce(updateAlignments, 100), false);

  /**
   * Update dropdown alignments.
   */
  function updateAlignments() {
    document.querySelectorAll(dropdownMenuSlct).forEach(dropdown => updateAlignment(dropdown));

    /**
     * @param {HTMLUListElement} dropdown
     */
    function updateAlignment(dropdown) {
      let ancestor = dropdown.parentElement;

      while (ancestor && !(ancestor === document.body || getComputedStyle(ancestor).getPropertyValue('overflow-x') === 'hidden')) {
        ancestor = ancestor?.parentElement;
      }
      if (!ancestor) {
        return;
      }

      const style = getComputedStyle(dropdown);
      const display = style.getPropertyValue('display');
      const visibility = style.getPropertyValue('visibility');

      if (display === 'none' && !['hidden', 'collapsed'].includes(visibility)) {
        dropdown.style.visibility = 'hidden';
        dropdown.style.display = 'block';
      }
      dropdown.parentElement?.classList.toggle(alignRightClsn, ancestor.getBoundingClientRect()?.right < dropdown.getBoundingClientRect()?.right);
      dropdown.style.display = null;
      dropdown.style.visibility = null;
    }
  }

  /**
   * @param {(...args) => void} callback
   * @param {number} duration - Milliseconds
   * @returns {(...args) => void}
   */
  function debounce(callback, duration) {
    let timeout = null;

    return debouncer;

    /**
     * @param {any[]} args
     */
    function debouncer(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback.apply(this, args);
        timeout = null;
      }, duration);
    }
  }
}());
